<template>
  <div class="grid-wrapper grid grid-cols-6 gap-y-8 gap-x-6 laptop:grid-cols-8 laptop:gap-y-10">
    <EnvironmentParagraphNextImages
      class="order-2 laptop:order-1"
      :title="data?.companyPage?.data?.attributes?.recycling_title || ''"
      :text="data?.companyPage?.data?.attributes?.recycling_description || ''"
    />
    <div
      class="order-1 col-span-6 col-start-1 mx-auto w-full max-w-[100%] tablet:max-w-[60%] laptop:order-2 laptop:col-span-3 laptop:col-start-6 laptop:mx-0 laptop:max-w-full"
    >
      <div class="relative flex h-0 items-center justify-center overflow-hidden pt-[100%]" ref="recycleContainer">
        <!--        <svg
          class="mask absolute top-0 left-0 z-10 h-full w-full"
          width="311"
          height="300"
          viewBox="0 0 311 300"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M144.957 205.42L142.32 269.948L141.969 273.806L68.1602 268.721C63.9425 268.37 60.0178 266.529 56.3859 263.197C52.754 259.866 50.0008 256.037 48.1263 251.712C46.8376 248.556 45.9882 245.341 45.5782 242.068C45.1681 238.795 45.4024 234.996 46.2811 230.67C47.1598 226.345 47.8627 223.131 48.3899 221.026C48.9171 218.922 50.1766 215.181 52.1682 209.804C54.1599 204.427 55.2729 201.329 55.5072 200.511C64.6455 201.914 94.4619 203.55 144.957 205.42ZM76.9469 102.667L108.579 169.124L82.7462 152.992C75.3653 161.408 68.8338 169.854 63.1517 178.329C57.4696 186.804 53.2227 194.111 50.4109 200.248C47.5991 206.385 45.2853 211.908 43.4693 216.818C41.6534 221.728 40.5697 225.41 40.2182 227.865L39.5153 231.547L6.12558 168.948C4.13391 165.909 3.0795 162.636 2.96234 159.129C2.84518 155.622 3.19665 152.875 4.01675 150.887L5.42264 147.731C9.52313 140.367 16.2011 129.378 25.4565 114.766L0.853516 99.6861L76.9469 102.667ZM293.277 193.321L260.239 256.271C258.833 259.661 256.695 262.379 253.825 264.425C250.954 266.471 248.406 267.669 246.18 268.019L243.017 268.721C234.699 269.539 221.87 270.241 204.531 270.825L205.937 299.582L165.518 235.229L202.598 171.754L203.828 202.089C223.745 203.959 240.322 204.251 253.561 202.966C266.8 201.68 276.758 199.751 283.436 197.179L293.277 193.321ZM155.325 31.3006C149.819 38.6652 134.295 64.0906 108.755 107.577L53.0469 74.7867L49.7079 72.6826L89.2484 10.2589C91.5915 6.63511 95.1062 4.0049 99.7925 2.36832C104.479 0.731747 109.165 0.147256 113.851 0.614849C116.663 0.848645 119.504 1.55003 122.375 2.71902C125.245 3.888 127.705 5.11543 129.755 6.40131C131.806 7.68719 134.237 9.61601 137.048 12.1878C139.86 14.7595 141.969 16.776 143.375 18.2372C144.781 19.6985 146.89 22.0072 149.701 25.1635C152.513 28.3197 154.388 30.3654 155.325 31.3006ZM270.432 85.1322L307.687 148.783C309.796 153.109 310.529 157.551 309.884 162.11C309.24 166.669 307.629 170.994 305.051 175.085C303.528 177.423 301.595 179.586 299.252 181.573C296.909 183.561 294.683 185.197 292.574 186.483C290.465 187.769 287.624 189.055 284.051 190.341C280.478 191.626 277.725 192.562 275.792 193.146C273.858 193.731 270.842 194.549 266.741 195.601C262.641 196.653 259.946 197.354 258.657 197.705C254.674 189.288 239.151 163.805 212.087 121.254L267.093 87.061L270.432 85.1322ZM245.301 45.5037L270.256 30.9499L231.594 96.3545L157.961 92.8475L184.497 77.7676C180.514 67.3637 176.12 57.6612 171.317 48.66C166.513 39.6588 162.091 32.4404 158.049 27.0046C154.007 21.5688 150.229 16.8929 146.714 12.9768C143.199 9.06074 140.446 6.34286 138.454 4.82318L135.467 2.54367L206.64 2.71902C210.271 2.36832 213.669 2.98204 216.832 4.56016C219.996 6.13829 222.28 7.80409 223.686 9.55756L225.619 12.1878C230.188 19.3186 236.749 30.4239 245.301 45.5037Z"
            fill="#000"
          />
        </svg>-->

        <img
          class="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"
          src="/images/company/recycle_image.png"
          alt=""
          ref="recycleFull"
        />

        <img
          class="absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2"
          src="/images/company/recycle.png"
          alt=""
        />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { useWaitForPageTransitionEnd } from "~~/composables/waitPageTransition";
import { Companypage2DataKey } from "~/symbols/symbols";
const data = inject(Companypage2DataKey);

const recycleFull = ref<HTMLElement | null>(null);
const recycleContainer = ref<HTMLElement | null>(null);
const mask = ref<HTMLElement | null>(null);

const { promise } = useWaitForPageTransitionEnd();

onMounted(() => {
  initAnimation();
});

let tween = null;

onBeforeUnmount(() => {
  if (tween) {
    tween.kill;
    tween = null;
  }
  // ScrollTrigger.killAll();
});

async function initAnimation() {
  await promise.value;

  tween = gsap.from(recycleFull.value, {
    scrollTrigger: {
      trigger: recycleContainer.value,
      start: "top 60%",
      end: "center center-=100",
      scrub: true,
    },
    opacity: 0,
  });
}
</script>
<style lang="scss" scoped>
.mask {
  background-color: #fbfef9;
  color: rgb(0, 0, 0);
  mix-blend-mode: screen;
}
</style>
